import { productMap_diesel_ring_PROD_expanded } from './DIESEL_PROD';
import { productMap_diesel_ring_STAGING } from './DIESEL_STAGING';

// Environment-based product map export
// Uses PRODUCTION variants in production, STAGING variants otherwise
export const productMap_diesel_ring =
  process.env['NEXT_PUBLIC_ENVIRONMENT'] === 'PRODUCTION'
    ? productMap_diesel_ring_PROD_expanded
    : productMap_diesel_ring_STAGING;
